module.exports = __webpack_public_path__ + "static/img/jsczt_logo.4044742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jsczt_logo.png
// module id = vgzQ
// module chunks = 1